import { Dialog, DialogContent, DialogTitle, DialogActions, Button, CircularProgress, Alert, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import CommonGrid from "../../Repository/CommonGrid";
import { useDispatch, useSelector } from "react-redux";
import { getTemplatePath } from "./LocalRevisionHistory";
import { api } from "../../../redux/api";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from "../../../redux/slices/treeSlice";
import ServerRevisionCommentModal from "./ServerRevisionCommentModal";
import ErrorModal from "../../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import axios from 'axios';

function CustomIconRenderer(params) {
  return (
    <>
      <div style={{ display: "flex" }}>
        <span className={"REVISION_HISTORY"} style={{ margin: "5px" }}></span>
        <p style={{ margin: "0px 5px" }}>{params.value}</p>
      </div>
    </>
  );
}
function ServerRevisionHistory(props) {
  const { t } = useTranslation();
  const { openModal, toggle } = props;
  const [gridApi, setGridApi] = useState(null);
  const parentScreen = useContext(ParentScreenCtx);
  const selectedNode = useSelector(state=>state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const {user, account, baseUrl, token} = useSelector(state => state.queryParams);
  const { type, workflowGroup, title } = selectedNode;
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [alertModal, setAlertModal] = useState({
    isOpen: false,
    message: "",
    type: "info",
  });
  const [compareModal, setCompareModal] = useState(false);
  const [htmlContent, setHtmlContent] = useState(null);
  const [diffLoading, setDiffLoading] = useState(false);
  const [path, setPath] = useState('');
  const [commentModal, setCommentModal] = useState({
    openModal: false,
    params: ''
  });
  const [rowData, setRowData] = useState([]);
  const [associatedFilesData, setAssociatedFilesData] = useState([]);
  const [selectedRevisionForAssociatedFiles, setSelectedRevisionForAssociatedFiles] = useState(null);
  const [selectedAssociatedFiles, setSelectedAssociatedFiles] = useState([]);
  const [associatedFilesGridApi, setAssociatedFilesGridApi] = useState(null);
  
  const gridOptions = {
    columnDefs : [
        {
            headerName:t('REVISION_ID'),
            field:'revision_id',
            showPlaceholder: false,
            resizable: true,
            cellRenderer:CustomIconRenderer,
            flex:1
        },
        {
            headerName:t('USER_INTRACT_USERNAME'),
            field:'user',
            showPlaceholder: false,
            resizable: true,
            flex:1
        },
        {
            headerName:t('DATE_'),
            field:'date',
            showPlaceholder: false,
            resizable: true,
            flex:1
        },
        {
            headerName:t('LBL_NEW_COMMENT'),
            field:'comment',
            showPlaceholder: false,
            resizable: true,
            flex:1
        },
        {
            headerName:'Related Files',
            field:'related_files',
            showPlaceholder: false,
            resizable: true,
            flex:1
        },
    ],
  };

  const associatedFilesGridOptions = {
    columnDefs: [
      {
        headerName: t('REVISION_ID'),
        field: 'revision_id',
        showPlaceholder: false,
        resizable: true,
        cellRenderer: CustomIconRenderer,
        flex: 1,
      },
      {
        headerName: t('USER_INTRACT_USERNAME'),
        field: 'user',
        showPlaceholder: false,
        resizable: true,
        flex: 1,
      },
      {
        headerName: t('DATE_'),
        field: 'date',
        showPlaceholder: false,
        resizable: true,
        flex: 1,
      },
      {
        headerName: t('MNU_FILE'),
        field: 'path',
        showPlaceholder: false,
        resizable: true,
        flex: 2,
      },
    ],
  };


  
  function onSelectionChanged() {
    const rows = gridApi.getSelectedNodes();
    if(rows.length > 0){
     const rowData= rows.map((row) =>{
       return row.data
      })
      setSelectedRows(rowData)
      
      // Handle associated files display for single selection
      if(rows.length === 1) {
        const selectedRow = rows[0].data;
        if(selectedRow.relatedGroup && Array.isArray(selectedRow.relatedGroup) && selectedRow.relatedGroup.length > 0) {
          // Convert relatedGroup data to the format expected by the associated files grid
          const associatedFiles = selectedRow.relatedGroup.map((file, index) => ({
            id: index,
            revision_id: file.revisionId,
            user: file.lastModifiedUser,
            date: file.lastModifiedDate,
            path: file.path
          }));
          setAssociatedFilesData(associatedFiles);
          setSelectedRevisionForAssociatedFiles(selectedRow);
        } else {
          setAssociatedFilesData([]);
          setSelectedRevisionForAssociatedFiles(null);
        }
      } else {
        setAssociatedFilesData([]);
        setSelectedRevisionForAssociatedFiles(null);
      }

      setSelectedAssociatedFiles([]);
    }
  }
  
  const onCellDoubleClicked = (params) => {
    setCommentModal((prevState) => ({
      openModal: true,
      params: params,
    }));
  };
  
  const onCloseCommentModal = () => {
    setCommentModal((prevState) => ({
      ...prevState,
      openModal: false,
    }));
  }

  const onAlertClose = () =>
    setAlertModal({ isOpen: false, message: "", type: "info" });
  
  const handleCancelClick = () => {
    toggle();
    setSelectedRows([]);
  };
  
  const compareModalHandler = () => {
    setCompareModal(!compareModal);
    if (!compareModal) {
      setHtmlContent(null);
    }
  };
  
  const fetchDiffContent = async (firstRev, secondRev) => {
    setDiffLoading(true);
    try {
      const url = `${baseUrl}/workbench?user=${user}&action=get_server_revision_diff&account=${account}&path=${path}&rev_id1=${firstRev.revision_id}&rev_id2=${secondRev.revision_id}`;
      
      const response = await axios(url, {
        responseType: "text",
        headers: { "Authorization": `Bearer ${token}` },
      });
      
      setHtmlContent(response.data);
    } catch (error) {
      console.error("Error fetching diff:", error);
      setHtmlContent(error.response?.data || "Error fetching diff data");
    } finally {
      setDiffLoading(false);
    }
  };
  
  const getGridAPI = (api) => {
    setGridApi(api);
  };

  const getAssociatedFilesGridAPI = (api) => {
    setAssociatedFilesGridApi(api);
  };

  function onAssociatedFilesSelectionChanged() {
    const rows = associatedFilesGridApi.getSelectedNodes();
    if (rows.length > 0) {
      const rowData = rows.map((row) => {
        return row.data;
      });
      setSelectedAssociatedFiles(rowData);
    } else {
      setSelectedAssociatedFiles([]);
    }
  }
  
  const handleRetrieveAction = () => {
    if(selectedRows.length === 0){
    setErrorModal(true)
    setErrorMessage(t('BOX_RETRIEVE_ALERT'))
    return;
  }
    if(selectedRows.length === 1){
      const payloadMap = {
        inbound: 'TEMPLATE',
        outbound: 'TEMPLATE',
        workflow: 'WORKFLOW_DEFINITION'
      }
      dispatch(treeActions.setRightTreeLoading({ screen: parentScreen, data: true }));
      dispatch(api.endpoints.getTemplateByServerRevId.initiate({
        account:account,
        path:selectedRows[0].path,
        revId:selectedRows[0].revision_id
      }, {forceRefetch: true})).then(res => {
        ["header","body","trailer"].forEach(e =>{
          dispatch(treeActions.setRightTreeSelectedNode({screen: parentScreen, type: e, data: {}}))
          dispatch(treeActions.setRightTreeData({screen: parentScreen, type: e, data: []}));
          dispatch(treeActions.setNewRightTreeTranslatedData({screen: parentScreen, type: e, data: []}))
        })
        dispatch(treeActions.setRetrievedData({ screen: parentScreen, [payloadMap[parentScreen]]: res?.data?.data?.data.TEMPLATE || res?.data?.data?.data?.WORKFLOW_DEFINITION }))
      })
      handleCancelClick()
    }
  }
  
  const handleCompareAction = () => {
    if(selectedRows?.length === 2){
      const revisionArray = [...selectedRows];
      revisionArray.sort((a,b) =>{
        return a.revision_id - b.revision_id;
      });
      
      fetchDiffContent(revisionArray[0], revisionArray[1]);
      compareModalHandler();
    }
    else {
       setErrorModal(true);
       setErrorMessage(t('BOX_SEL_REV'));
    }
  }

  const getApiTypeFromPath = (filePath) => {
    if (filePath.includes('inbound_templates/')) {
      return 'saveUserInboundTemplate';
    } else if (filePath.includes('outbound_templates/')) {
      return 'saveUserOutboundTemplate';
    } else {
      return 'saveUserWorkflowTemplate';
    }
  };

  // Helper function to get template name and workflow group from file path
  const getTemplateDetailsFromPath = (filePath) => {
    const pathParts = filePath.split('/');
    if (pathParts.length >= 3) {
      const workflowGroup = pathParts[1];
      let templateName;
      
      if (filePath.includes('inbound_templates/') || filePath.includes('outbound_templates/')) {
        // For inbound/outbound: account/workflowGroup/template_type/templateName
        templateName = pathParts[3];
      } else {
        // For workflow: account/workflowGroup/templateName
        templateName = pathParts[2];
      }
      
      return { workflowGroup, templateName };
    }
    
    return {
      workflowGroup: workflowGroup,
      templateName: title
    };
  };

  const handleRetrieveGroupAction = async () => {
    if (selectedAssociatedFiles.length === 0) {
      setAlertModal({
        isOpen: true,
        message: "You must select one or more files from the Associated File table (Bottom table).",
        type: "warning",
      });
      return;
    }

    try {
      const retrievePromises = selectedAssociatedFiles.map(async (file) => {
        try {
          // Remove file extension from path before sending to API
          const pathWithoutExtension = file.path.replace(/\.(png|jpeg|gif|jpg|pdf|html|xml|json)$/i, '');
          
          const response = await dispatch(
            api.endpoints.getTemplateByServerRevId.initiate({
              account: account,
              path: pathWithoutExtension,
              revId: file.revision_id,
            }, {forceRefetch: true})
          ).unwrap(); 
          
          if (response?.data?.data?.TEMPLATE || response?.data?.data?.WORKFLOW_DEFINITION) {
            const apiType = getApiTypeFromPath(file.path);
            const { workflowGroup: fileWorkflowGroup, templateName } = getTemplateDetailsFromPath(file.path);
            
            await dispatch(api.endpoints[apiType].initiate({
              account: account,
              workflowGroupName: fileWorkflowGroup,
              templateName: templateName,
              data: response?.data?.data
            }, {forceRefetch: true})).unwrap();
            
            return {
              file: file.path,
              success: true,
              response
            };
          } else {
            return {
              file: file.path,
              success: false,
              response
            };
          }
        } catch (error) {
          console.error(`Error retrieving file ${file.path}:`, error);
          return {
            file: file.path,
            success: false,
            error
          };
        }
      });

      // Wait for all API calls to complete
      const results = await Promise.allSettled(retrievePromises);
      
      // Process results
      let successCount = 0;
      const totalFiles = selectedAssociatedFiles.length;
      
      results.forEach((result, index) => {
        if (result.status === 'fulfilled' && result.value.success) {
          successCount++;
        } else {
          console.error(`Failed to retrieve file ${selectedAssociatedFiles[index].path}:`, 
            result.status === 'rejected' ? result.reason : result.value.error);
        }
      });

      // Show appropriate message based on results
      if (successCount === totalFiles) {
        setAlertModal({
          isOpen: true,
          message: `Successfully retrieved ${successCount} file(s).`,
          type: "success",
        });
      } else if (successCount > 0) {
        setAlertModal({
          isOpen: true,
          message: `Retrieved ${successCount} out of ${totalFiles} file(s). Some files failed to retrieve.`,
          type: "warning",
        });
      } else {
        setAlertModal({
          isOpen: true,
          message: "Failed to retrieve any files.",
          type: "error",
        });
      }

      if (successCount > 0) {
        handleCancelClick();
      }
    } catch (error) {
      console.error("Error in handleRetrieveGroupAction:", error);
      setAlertModal({
        isOpen: true,
        message: "Error occurred while retrieving files.",
        type: "error",
      });
    }
  };
  
  useEffect(() => {
    if (openModal && Object.keys(selectedNode).length > 0) {
      // Reset associated files data when opening for a different file
      setAssociatedFilesData([]);
      setSelectedRevisionForAssociatedFiles(null);
      setSelectedRows([]);
      setSelectedAssociatedFiles([]);
      
      const templatePath = getTemplatePath(account, workflowGroup, type, title).split('.').slice(0,-1).join('');
      setPath(templatePath);
      
      dispatch(
        api.endpoints.getServerRevisionhistory.initiate(
          {
            account,
            path: templatePath,
          },
          { forceRefetch: true }
        )
      )
        .then((response) => {
          const data = response.data.data;
          if (response.data.current_state === "SUCCESS") {
            const updatedRowData = data.map((row, index) => {
              // Process associated files from relatedGroup
              let associatedFilesText = "";
              if (row.relatedGroup && Array.isArray(row.relatedGroup) && row.relatedGroup.length > 0) {
                associatedFilesText = `${row.relatedGroup.length} files uploaded with this file`;
              }
              
              return {
                id: index,
                revision_id: row.revisionId,
                user: row.lastModifiedUser,
                date: row.lastModifiedDate,
                comment: row.comment,
                path: row.path,
                related_files: associatedFilesText,
                relatedGroup: row.relatedGroup // Include the relatedGroup data for associated files display
              };
            });
            setRowData(updatedRowData);
          }
        })
        .catch((error) => {
          setRowData(['Error']);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [openModal, selectedNode, account, workflowGroup, type, title]);
   
  return (
    <>
      <Dialog
        open={openModal}
        onClose={handleCancelClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"md"}
        fullWidth>
        <DialogTitle className="dialog-header">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="title">{t("LBL_SERVER_REV")}</div>
            <IconButton
              onClick={handleCancelClick}
              sx={{ borderRadius: "5px" }}>
              <CloseIcon
                sx={{ height: "28px", width: "28px", color: "#777777" }}
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent sx={{ height: "650px", padding: 0 }} dividers>
          <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
            {/* Header Description */}
            <div className={"dialog-content"} style={{ 
              padding: "16px", 
              paddingBottom: "8px",
              flexShrink: 0
            }}>
              <span>{t("DIAG_REVISION_HISTORY_DESC")}</span>
            </div>
            
            {/* Main Revision History Grid */}
            <div style={{ 
              height: selectedRevisionForAssociatedFiles && associatedFilesData.length > 0 ? "250px" : "400px",
              padding: "0 16px",
              display: "flex",
              flexDirection: "column"
            }}>
              <CommonGrid
                rowData={rowData}
                gridOptions={gridOptions}
                getGridAPI={getGridAPI}
                isLoading={isLoading}
                gridProps={{
                  animateRows: false,
                  enableCellTextSelection: true,
                  ensureDomOrder: true,
                  rowSelection: "multiple",
                  onSelectionChanged: onSelectionChanged,
                  onCellDoubleClicked: onCellDoubleClicked,
                }}
                fullSize={true}
              />
            </div>

            {/* Main Grid Buttons */}
            <div style={{ 
              padding: "8px 16px", 
              display: "flex", 
              justifyContent: "flex-end",
              gap: "8px",
              flexShrink: 0
            }}>
              <Button
                size="small"
                variant={"outlined"}
                onClick={handleCompareAction}>
                {t("BTN_COMPARE")}
              </Button>
              <Button
                size="small"
                variant={"outlined"}
                onClick={handleRetrieveAction}>
                {t("BTN_RETRIEVE")}
              </Button>
            </div>

            {/* Associated Files Section */}
            {selectedRevisionForAssociatedFiles && associatedFilesData.length > 0 && (
              <>
                {/* Separator text */}
                <div style={{ 
                  padding: "8px 16px", 
                  fontSize: "12px",
                  borderTop: "1px solid #e0e0e0",
                  flexShrink: 0
                }}>
                  <span>The following files were uploaded at the same time as {selectedRevisionForAssociatedFiles.path}</span>
                </div>
                
                {/* Associated Files Grid */}
                <div style={{ 
                  height: "200px",
                  padding: "0 16px",
                  display: "flex",
                  flexDirection: "column"
                }}>
                  <CommonGrid
                    rowData={associatedFilesData}
                    gridOptions={associatedFilesGridOptions}
                    getGridAPI={getAssociatedFilesGridAPI}
                    isLoading={false}
                    gridProps={{
                      animateRows: false,
                      enableCellTextSelection: true,
                      ensureDomOrder: true,
                      rowSelection: "multiple",
                      onSelectionChanged: onAssociatedFilesSelectionChanged,
                    }}
                    fullSize={true}
                  />
                </div>

                {/* Retrieve button for associated files */}
                <div style={{ 
                  padding: "8px 16px", 
                  display: "flex", 
                  justifyContent: "flex-end",
                  gap: "8px",
                  flexShrink: 0
                }}>
                  <Button
                    size="small"
                    variant={"outlined"}
                    onClick={handleRetrieveGroupAction}
                    disabled={selectedAssociatedFiles.length === 0}>
                    {t("BTN_RETRIEVE")}
                  </Button>
                </div>
              </>
            )}
            
            <div className={"diag-lrh-ib_footer"} style={{ 
              padding: "8px 16px", 
              flexShrink: 0,
              marginTop: "auto"
            }}>
              <span>{t("DIAG_COMMENT_HINT")}</span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      
      {commentModal.openModal && (
        <ServerRevisionCommentModal
          commentModalState={commentModal}
          onClose={onCloseCommentModal}
        />
      )}
      
      {errorModal && (
        <ErrorModal
          errorModal={errorModal}
          handleErrorModal={() => setErrorModal(false)}
          errorMessage={errorMessage}
          errorType={t("BOX_ERR")}></ErrorModal>
      )}
      
      <Dialog
        open={compareModal}
        onClose={compareModalHandler}
        aria-labelledby="diff-dialog-title"
        aria-describedby="diff-dialog-description"
        maxWidth={"xl"}
        fullWidth
      >
        <DialogTitle>
          <div className="compare-local-revision_header dialog-header">
            <h1>{path}</h1>
          </div>
        </DialogTitle>
        <DialogContent className="compare-local-revisions_body height-100" dividers>
          <div id="local-revision-diff-container" style={{ height: '100%' }}>
            {htmlContent ? (
              <iframe
                srcDoc={htmlContent}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="HTML Content Viewer"
              ></iframe>
            ) : diffLoading ? (
              <div className='loading-overlay' style={{ marginTop: "15%", display: "grid", gap: "20px" }}>
                <CircularProgress size={"4rem"} />
                <div>{t('LOADING_IND')}</div>
              </div>
            ) : (
              ""
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            onClick={compareModalHandler}
            variant={"outlined"}
          >
            {t('BTN_CLOSE')}
          </Button>
        </DialogActions>
      </Dialog>

      {alertModal.isOpen && (
        <Snackbar
          open={alertModal.isOpen}
          autoHideDuration={6000}
          onClose={onAlertClose}>
          <Alert
            severity={alertModal.type}
            onClose={onAlertClose}
            variant="filled"
            sx={{
              width: "100%",
              maxWidth: "450px",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}>
            {alertModal.message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default ServerRevisionHistory;
